import React from 'react';
import { Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import { GetUserEmail } from '../services/get-user-email';
import { ReconciliationWorkFlow } from './workflows/reconciliation-workflow';
import { FinancialReportWorkFlow } from './workflows/financial-analysis-report-workflow';
import { InvoiceExtractionWorkFlow } from './workflows/invoice-extraction-workflow';
import { ArcosWorkflow } from './workflows/arcos-workflow';

const CombinationInfoPanel = ({
  workato_recipe_id,
  workflowData,
  activeTab,
  connectionsData,
  this_folder_id = null,
  this_sheet_id = null,
  manual = false,
  arc_tab_ref1,
  arc_tab_ref2,
  webhook_url,
  recipeSetupStatus,
  recipeActive,
  connected,
  refreshTheRecipe,
  setRecipeDisabled,
}) => {
  const email = GetUserEmail();
  const invoiceExtraction_combos = [1, 8, 9, 13, 15];
  const reconciliation_combos = [10, 12, 14];
  const financeReport_combos = [11];
  const arcos_combo = [168];

  return (
    <>
      {invoiceExtraction_combos.includes(workflowData.id) ? (
        <InvoiceExtractionWorkFlow
          workato_recipe_id={workato_recipe_id}
          combination_id={workflowData.id}
          connectors={workflowData?.connectors}
          triggers={workflowData?.triggers}
          activeTab={activeTab}
          arc_tab_ref1={arc_tab_ref1}
          arc_tab_ref2={arc_tab_ref2}
          webhook_url={webhook_url}
          this_folder_id={this_folder_id}
          this_sheet_id={this_sheet_id}
          email={email}
          connections_data={connectionsData}
          recipeSetupStatus={recipeSetupStatus}
          recipeActive={recipeActive}
          manual={manual}
          connected={connected}
          refreshTheRecipe={refreshTheRecipe}
          setRecipeDisabled={setRecipeDisabled}
        />
      ) : reconciliation_combos.includes(workflowData.id) ? (
        <ReconciliationWorkFlow
          workato_recipe_id={workato_recipe_id}
          combination_id={workflowData.id}
          connectors={workflowData?.connectors}
          activeTab={activeTab}
          arc_tab_ref1={arc_tab_ref1}
          arc_tab_ref2={arc_tab_ref2}
          webhook_url={webhook_url}
          email={email}
          recipeSetupStatus={recipeSetupStatus}
          recipeActive={recipeActive}
          refreshTheRecipe={refreshTheRecipe}
        />
      ) : financeReport_combos.includes(workflowData.id) ? (
        <FinancialReportWorkFlow
          workato_recipe_id={workato_recipe_id}
          combination_id={workflowData.id}
          connectors={workflowData?.connectors}
          activeTab={activeTab}
          arc_tab_ref1={arc_tab_ref1}
          arc_tab_ref2={arc_tab_ref2}
          webhook_url={webhook_url}
          email={email}
          recipeSetupStatus={recipeSetupStatus}
          recipeActive={recipeActive}
          refreshTheRecipe={refreshTheRecipe}
        />
      ) : arcos_combo.includes(workflowData.id) ? (
        <ArcosWorkflow
          workato_recipe_id={workato_recipe_id}
          combination_id={workflowData.id}
          connectors={workflowData?.connectors}
          activeTab={activeTab}
          arc_tab_ref1={arc_tab_ref1}
          arc_tab_ref2={arc_tab_ref2}
          webhook_url={webhook_url}
          email={email}
          recipeSetupStatus={recipeSetupStatus}
          recipeActive={recipeActive}
          connected={connected}
          refreshTheRecipe={refreshTheRecipe}
          setRecipeDisabled={setRecipeDisabled}
        />
      ) : !manual ? (
        workflowData?.triggers.map((trigger) => {
          return activeTab === 'wf-trigger-' + trigger.id ? (
            <Col key={'trigger-info-' + trigger.id}>
              <header>
                <img src={`/images/${trigger.icon}`} className="icon-solutions float-left" alt={trigger.name} />
              </header>
              <div>{trigger.name}</div>
            </Col>
          ) : null;
        })
      ) : null}

      {workflowData?.connectors.map((connector, key) => {
        // for now we are excluding the above custom defined workflows from the below loop setup
        return activeTab === 'wf-conn-' + key &&
          !invoiceExtraction_combos.includes(workflowData.id) &&
          !reconciliation_combos.includes(workflowData.id) &&
          !financeReport_combos.includes(workflowData.id) &&
          !arcos_combo.includes(workflowData.id) ? (
          <Col className="basic-form" key={'conn-info' + connector?.id}>
            <header>
              <img src={`/images/${connector?.icon}`} className="icon-solutions float-left" alt={connector?.name} />
            </header>

            {connector?.provider === 'google_drive' ? (
              this_folder_id !== null ? (
                <a target={'_blank'} rel="noopener" href={`https://drive.google.com/drive/folders/${this_folder_id}`}>
                  Go to Gdrive Folder
                </a>
              ) : null
            ) : connector?.provider === 'manual_upload' ? (
              /**
               * Manual Upload file form
               *  */
              <>
                <h3>Upload your file</h3>
                <input type="file" onChange={onFileChange} />
                <Button
                  variant="primary"
                  type="submit"
                  onClick={onFileUpload}
                  className="mt-3 px-4"
                  disabled={isPreloading}
                >
                  Upload Invoice
                </Button>
              </>
            ) : connector?.provider === 'xero' ? (
              <>
                <h3>Xero Output</h3>
                <p>Once the Arcanum process has completed we will send the result to your Xero account.</p>
              </>
            ) : connector?.provider === 'manual_email' ? (
              <>
                <h3>Email Output</h3>
                <p>Once the Arcanum process has completed we will send the result to your email inbox.</p>
              </>
            ) : connector?.provider === 'google_sheets' ? (
              this_sheet_id !== null ? (
                <a target={'_blank'} rel="noopener" href={`https://docs.google.com/spreadsheets/d/${this_sheet_id}`}>
                  Go to Spreadsheet
                </a>
              ) : null
            ) : (
              <div>{connector?.name}</div>
            )}
          </Col>
        ) : null;
      })}
    </>
  );
};

export { CombinationInfoPanel };
